import { createFileRoute } from '@tanstack/react-router'
import PlusIcon from '~/components/icons/PlusIcon'
import { EstablishmentsPanel } from '~/components/routes/sellers/EstablishmentsPanel'
import { SellersPageLayout } from '~/components/routes/sellers/sellers-page-layout'
import { SELLERS_TAB_PERMISSIONS } from '~/components/routes/sellers/tabs'
import { AuthorizedButtonLink, withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/sellers/establishments')({
  staticData: {
    permission: SELLERS_TAB_PERMISSIONS.establishments,
  },
  component: EstablishmentsTabPage,
})
withRoutePermissions(Route)

function EstablishmentsTabPage() {
  return (
    <SellersPageLayout
      activeTab="establishments"
      actions={
        <AuthorizedButtonLink
          variant="contained"
          to="/sellers/establishment/new"
          legacyRights={['ADMIN']}
        >
          <PlusIcon />
          Ajouter un établissement
        </AuthorizedButtonLink>
      }
    >
      <EstablishmentsPanel />
    </SellersPageLayout>
  )
}
